// 添加区域配置
export const areaOption = {
        maxHeight:400,
        cellBtn:false,
        addBtn:false,
        header:false,
        menu:false,
        index:true,
        indexLabel:"序号",
        height: 'auto',
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        viewBtn: true,
        column:[
                {
                        label:'区域编号',
                        prop:'code'

                },
                {
                        label:'区域名称',
                        prop:'name'

                },
                {
                        label:'区域全程',
                        prop:'fullName'

                },
                {
                        label:"所属部门",
                        prop:'$deptId'

                }
        ]
}
// 添加设备配置
export const deviceOption = {
        maxHeight:400,
        cellBtn:false,
        addBtn:false,
        header:false,
        menu:false,
        index:true,
        indexLabel:"序号",
        height: 'auto',
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        viewBtn: true,
        column:[
                {
                        label: '设备名称',
                        prop: 'name',
                },
                {
                        label: '设备编号',
                        prop: 'code',
                },
                {
                        label: '设备类型',
                        prop: 'typeName',
                },

                {
                        label: '所属部门',
                        prop: 'deptName',
                },
                {
                        label: '存放位置',
                        prop: 'areaName',
                },

                {
                        label: '标准',
                        prop: 'standardName',
                        slot:true
                },
        ]
}

export function omitNumber(e) {
        let value = e;
        if(value.indexOf(".")<0){
        value = value.slice(0,9)
        }
        if(value.indexOf(".")>=9){
        value = value.slice(0,9) + value.slice(value.indexOf("."))
        }
        value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
        if (value.indexOf(".") < 0 && value != "") {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value);
        }
        if(value=='.'){
                value = '0.'
        }
        return value;
}

export const weeksDict =
        [
                {
                        label: '周一',
                        value: "1"
                },
                {
                        label: '周二',
                        value: "2"
                },
                {
                        label: '周三',
                        value: '3'
                },
                {
                        label: '周四',
                        value: '4'
                },
                {
                        label: '周五',
                        value: '5'
                },
                {
                        label: '周六',
                        value: '6'
                },
                {
                        label: '周日',
                        value: '7'
                },


        ]


export const monthDict = [

                {
                        label: 1,
                        value: '1'
                },
                {
                        label: 2,
                        value: '2'
                },
                {
                        label: 3,
                        value: '3'
                },
                {
                        label: 4,
                        value: '4'
                },
                {
                        label: 5,
                        value: '5'
                },
                {
                        label: 6,
                        value: '6'
                },
                {
                        label: 7,
                        value: '7'
                },
                {
                        label: 8,
                        value: '8'
                },
                {
                        label: 9,
                        value: '9'
                },
                {
                        label: 10,
                        value: '10'
                },
                {
                        label: 11,
                        value: '11'
                },
                {
                        label: 12,
                        value: '12'
                },
                {
                        label: 13,
                        value: '13'
                },
                {
                        label: 14,
                        value: '14'
                },
                {
                        label: 15,
                        value: '15'
                },
                {
                        label: 16,
                        value: '16'
                },
                {
                        label: 17,
                        value: '17'
                },
                {
                        label: 18,
                        value: '18'
                },
                {
                        label: 19,
                        value: '19'
                },
                {
                        label: 20,
                        value: '20'
                },
                {
                        label: 21,
                        value: '21'
                },
                {
                        label: 22,
                        value: '22'
                },
                {
                        label: 23,
                        value: '23'
                },
                {
                        label: 24,
                        value: '24'
                },
                {
                        label: 25,
                        value: '25'
                },
                {
                        label: 26,
                        value: '26'
                },
                {
                        label: 27,
                        value: '27'
                },
                {
                        label: 28,
                        value: '28'
                },
                {
                        label: 29,
                        value: '29'
                },
                {
                        label: 30,
                        value: '30'
                },
                {
                        label: 31,
                        value: '31'
                },



]